import _ from 'lodash';

export const SURVEY_TYPE = 'SURVEY';
const OBJECT_TYPE = 'OBJECT';
const UC_TYPE = 'UC';
const ABOUT_TYPE = 'ABOUT';
const KNOW_MORE_TYPE = 'KNOW_MORE';
const NAVIGABLE_TYPES = [OBJECT_TYPE, SURVEY_TYPE];

const orderOf = item => Number(_.get(item, 'itemOrder')) || 0;

const asArray = value => (Array.isArray(value) ? value : []);

const isContentChild = item =>
  !asArray(_.get(item, 'tags')).includes(ABOUT_TYPE) &&
  _.get(item, 'type') !== KNOW_MORE_TYPE;

export function interleaveSurveys(children, surveys) {
  const sortedSurveys = _.sortBy(asArray(surveys), orderOf);
  const merged = [];
  let surveyIndex = 0;
  asArray(children).forEach(child => {
    while (
      surveyIndex < sortedSurveys.length &&
      orderOf(sortedSurveys[surveyIndex]) < orderOf(child)
    ) {
      merged.push(sortedSurveys[surveyIndex]);
      surveyIndex += 1;
    }
    merged.push(child);
  });
  return merged.concat(sortedSurveys.slice(surveyIndex));
}

export function mergeCourseLevelItems(course) {
  const children = asArray(_.get(course, 'children')).filter(isContentChild);
  const about = { ..._.get(course, 'about.0', null), type: ABOUT_TYPE };
  return [about].concat(interleaveSurveys(children, _.get(course, 'surveys')));
}

export function indexCourseLevelItems(items) {
  let position = 0;
  return asArray(items).map(item => {
    const indexed = { ...item, index: position };
    if (_.get(item, 'type') !== SURVEY_TYPE) position += 1;
    return indexed;
  });
}

const ucNavigableItems = uc => {
  const items = asArray(uc.contentsAndAssessment || uc.children);
  return items.filter(item => NAVIGABLE_TYPES.includes(item.type));
};

const navigableItemsOf = item => {
  if (item.type === UC_TYPE) return ucNavigableItems(item);
  return NAVIGABLE_TYPES.includes(item.type) ? [item] : [];
};

export function buildNavigableItems(course) {
  return mergeCourseLevelItems(course).reduce(
    (items, item) => items.concat(navigableItemsOf(item)),
    []
  );
}
